package features.videoDetails.data.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("FavoriteData")
data class FavoriteData(
    val video: Video,
) {

    @Serializable
    @SerialName("Video")
    data class Video(
        val videoId: String,
        val imdbId: String? = null,
        val kinopoiskId: String? = null,
        val imageUrl: String? = null,
        val title: String? = null,
        val isTvShow: Boolean,
        val isDeleted: Boolean,
        val changedAt: String,
    )
}